import $ from 'jquery';

$('#filter').on('change', function(){
    $('#post-filters').trigger('submit');
});